module.exports = __webpack_public_path__ + "static/media/3D打印双足机器人.dfcb6b77.png";